import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { initMetaPixel } from './utils/metaPixel';
const Stats = lazy(() => import('./components/Stats').then(m => ({
  default: m.Stats
})));
const ForWho = lazy(() => import('./components/ForWho').then(m => ({
  default: m.ForWho
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const InstructorTestimonials = lazy(() => import('./components/InstructorTestimonials').then(m => ({
  default: m.InstructorTestimonials
})));
const ContentOverview = lazy(() => import('./components/ContentOverview').then(m => ({
  default: m.ContentOverview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const LegalPack = lazy(() => import('./components/LegalPack').then(m => ({
  default: m.LegalPack
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      let pixelLoaded = false;
      const loadPixel = () => {
        if (!pixelLoaded) {
          pixelLoaded = true;
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => initMetaPixel(), {
              timeout: 2000
            });
          } else {
            setTimeout(initMetaPixel, 100);
          }
        }
      };
      const events = ['scroll', 'click', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, loadPixel, {
          once: true,
          passive: true
        });
      });
      const timeout = setTimeout(loadPixel, 5000);
      return () => {
        events.forEach(event => window.removeEventListener(event, loadPixel));
        clearTimeout(timeout);
      };
    }
  }, []);
  return <div className="min-h-screen bg-brand-bg text-brand-text font-body" data-id="element-0">
      <Hero data-id="element-1" />

      <Suspense fallback={null} data-id="element-2">
        <Stats data-id="element-3" />
        <ForWho data-id="element-4" />
        <Benefits data-id="element-5" />
        <InstructorTestimonials data-id="element-6" />
        <ContentOverview data-id="element-7" />
        <Bonuses data-id="element-8" />
        <LegalPack data-id="element-9" />
        <Pricing data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <Footer data-id="element-14" />
      </Suspense>
    </div>;
}